<div
  class="sort-icon"
  [matMenuTriggerFor]="moreMenu"
  #trigger="matMenuTrigger"
  [ngClass]="{'active': trigger.menuOpened, 'sort-icon-next-to-filter': isNextToFilter}"
  (menuOpened)="menuMarkForCheck()"
  (menuClosed)="menuMarkForCheck()"
>
  <mat-icon
    svgIcon="sort"
    [ngClass]="{'active': trigger.menuOpen}"
  >
  </mat-icon>
  <span class="sort-label mojo-blue-hover">Sort by:
    {{currentSortBy$.getValue()}}</span>
</div>

<mat-menu
  #moreMenu="matMenu"
  class="more-menu no-padding"
  xPosition="before"
>
  <button
    *ngFor="let item of menuItems"
    mat-menu-item
    class="menu-button"
    (click)="sortBy(item)"
  >
    {{item.label}}
  </button>
</mat-menu>
